module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/164jvKs/tc-custom/9781459206700.jpg?1700281120675",
      "alt": "This image is the cover for the book Husband Assignment"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Husband Assignment\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("When Stephanie accepted an assignment to publicize a major film, she found herself having to negotiate with Raoul lanier, the powerful heir to a billionaire empire—and a ruthlessly sexy man…"), _c('br'), _c('br'), _vm._v("Stephanie simply had to stop fantasizing about Raoul. It was his "), _c('i', [_vm._v("business")]), _vm._v(" expertise she must concentrate on, not his bedroom technique! After all, they had a financial deal to settle. But then it became clear that the only merger Raoul had in mind was marriage!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Helen Bianchin\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Helen Bianchin was encouraged by a friend to write her own romance novel and she hasn’t stopped writing since! Helen’s interests include a love of reading, going to the movies, and watching selected television programs. She also enjoys catching up with friends, usually over a long lunch! A lover of animals, especially cats, she owns two beautiful Birmans. Helen lives in Australia with her husband. Their three children and six grandchildren live close by.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0